/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Modal, Tabs } from 'antd';
import { useIntl } from 'react-intl';
import { ModalProps } from 'antd/lib/modal';

import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { GeneralTab } from './Tabs/GeneralTab';
import { LogTab } from './Tabs/LogTab';
import { useArchiveSettings } from '~src/hooks/api-hooks/useArchiveSettings';
import { EditInviteModal } from '~components/popups-modals/EditInvite.modal';
import { DetailsEditInviteModal } from '~components/popups-modals/DetailsLogModal/Tabs/DetailsEditInvite.modal';

export const DetailsLogModal: React.FC<ModalProps> = ({
  projectId,
  tenderId,
  shareKey,
  onCancel,
  afterClose,
  detailLog,
  previousData,
  status,
  ...modalProps
}) => {
  const intl = useIntl();
  const archiveSettings = useArchiveSettings();
  const isTenderingOn =
    archiveSettings.data?.resArchiveSettings?.is_tendering_on;

  // console.log(`DetailsLogModal`, previousData);

  return (
    <Modal
      okButtonProps={{ hidden: true }}
      title={<ModalTitle text={intl.formatMessage({ id: 'details' })} />}
      cancelText={intl.formatMessage({ id: 'close' })}
      width="min(75vw, 550px)"
      bodyStyle={{ padding: '25px 25px 0 25px' }}
      centered
      destroyOnClose
      maskClosable={false}
      onCancel={onCancel}
      footer={
        window.sessionStorage.getItem('appState') !== 'timeMachine' && undefined
      }
      {...modalProps}>
      <Tabs style={{ marginTop: -40 }}>
        <Tabs.TabPane
          style={{ marginTop: 8 }}
          key="tags"
          tab={intl.formatMessage({ id: 'general-tab' })}>
          <GeneralTab previousData={previousData} />
        </Tabs.TabPane>
        <Tabs.TabPane
          style={{ marginTop: 8 }}
          key="edit"
          tab={intl.formatMessage({ id: 'edit-invite' })}>
          <DetailsEditInviteModal
            projectId={projectId}
            tenderId={tenderId}
            previousData={previousData}
            onCancel={onCancel}
          />
        </Tabs.TabPane>
        <Tabs.TabPane
          style={{ marginTop: 8 }}
          key="labels"
          tab={intl.formatMessage({ id: 'logs' })}>
          <LogTab
            previousData={previousData}
            detailLog={detailLog}
            status={status}
          />
        </Tabs.TabPane>
      </Tabs>
    </Modal>
  );
};
